module.exports = __webpack_public_path__ + "img/intersect-square.a9a923c7.svg";